import { render, staticRenderFns } from "./PrintOddsV2.vue?vue&type=template&id=153a9288"
import script from "./PrintOddsV2.vue?vue&type=script&lang=js"
export * from "./PrintOddsV2.vue?vue&type=script&lang=js"
import style0 from "./PrintOddsV2.vue?vue&type=style&index=0&id=153a9288&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports